import { OrbSubscriptionSchema } from '@cotera/api';
import React from 'react';
import z from 'zod/v3';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../components/ui/table';

type SubscriptionInfo = z.infer<typeof OrbSubscriptionSchema>;

export const SubscriptionSettings: React.FC<{
  subscriptions: SubscriptionInfo[];
}> = ({ subscriptions }) => {
  return (
    <div>
      {subscriptions.length > 0 && (
        <SubscriptionTable subscriptions={subscriptions} />
      )}
    </div>
  );
};

const SubscriptionTable: React.FC<{
  subscriptions: SubscriptionInfo[];
}> = ({ subscriptions }) => (
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead>Plan Name</TableHead>
        <TableHead>Start Date</TableHead>
        <TableHead>End Date</TableHead>
        <TableHead>Status</TableHead>
        <TableHead></TableHead> {/* Table actions column */}
      </TableRow>
    </TableHeader>

    <TableBody>
      {subscriptions.map((sub) => (
        <TableRow key={sub.orbSubscriptionId}>
          <TableCell>{sub.planName}</TableCell>
          <TableCell>{new Date(sub.startDate).toDateString()}</TableCell>
          <TableCell>
            {sub.endDate && new Date(sub.endDate).toDateString()}
          </TableCell>
          <TableCell>{sub.status}</TableCell>
          <TableCell>{/* Any buttons */}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
